// カートの Line: Properties にメッセージカードの本文のみを保存するためのアップデータ
// - チェックアウト時にカートを再構築し、各ラインに properties を付与します
// - 2つ目以降の商品の配送先情報も Line: Properties に保存します

(() => {
  let isProcessing = false;
  
  // メッセージカード必須項目の簡易検証（cart-attributes.js と同等の判定）
  function getMessageCardValidationErrors() {
    let messageMissing = false;
    let designMissing = false;
    const containers = document.querySelectorAll('.cart__attributes');
    containers.forEach((container) => {
      const lineNumber = container.dataset.line || '';
      const cardGroups = container.querySelectorAll('.cart-attribute__card-group');
      cardGroups.forEach((group, idx) => {
        const i = idx + 1;
        const cardRadio = group.querySelector(
          `input[name="properties[メッセージカード選択_${lineNumber}_${i}]"]:checked`
        );
        if (!cardRadio || cardRadio.value !== 'あり') return;

        // メッセージ必須
        const messageBox = group.querySelector(
          `textarea[name="properties[ギフトカードメッセージ_${lineNumber}_${i}]"]`
        );
        if (!messageBox || (messageBox.value || '').trim() === '') {
          messageMissing = true;
        }

        // デザイン必須（デザイン選択が存在する場合のみ）
        const designRadios = group.querySelectorAll(
          `input[name="properties[デザインパターン_${lineNumber}_${i}]"]`
        );
        if (designRadios && designRadios.length > 0) {
          const designRadioChecked = group.querySelector(
            `input[name="properties[デザインパターン_${lineNumber}_${i}]"]:checked`
          );
          if (!designRadioChecked) {
            designMissing = true;
          }
        }
      });
    });
    return { messageMissing, designMissing };
  }

  // 配送先フォームの必須項目バリデーション
  function getShippingValidationErrors() {
    const errors = [];
    
    // すべての「異なる配送先」チェックボックスを確認
    const checkboxes = document.querySelectorAll('.cart-attribute__different-shipping-checkbox');
    
    checkboxes.forEach(checkbox => {
      if (!checkbox.checked) return;
      
      const lineIndex = checkbox.getAttribute('data-line-index');
      const shippingForm = document.getElementById(`ShippingForm-${lineIndex}`);
      
      if (!shippingForm) return;
      
      // 必須フィールドを確認
      const requiredFields = shippingForm.querySelectorAll('.shipping-required-field');
      
      requiredFields.forEach(field => {
        const value = field.value.trim();
        
        if (!value) {
          // ラベルテキストを取得
          const labelEl = field.closest('.cart-attribute__field')?.querySelector('.cart-attribute__label');
          let labelText = 'フィールド';
          if (labelEl) {
            labelText = labelEl.textContent.replace('必須', '').trim();
          }
          errors.push(`商品${lineIndex}の配送先「${labelText}」を入力してください`);
          field.style.borderColor = '#dc3545';
        } else {
          field.style.borderColor = '';
        }
      });
    });
    
    return errors;
  }

  function showLoading(show = true) {
    let overlay = document.getElementById('cart-loading-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'cart-loading-overlay';
      overlay.style.position = 'fixed';
      overlay.style.inset = '0';
      overlay.style.background = 'rgba(0,0,0,0.45)';
      overlay.style.display = 'none';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';
      overlay.style.zIndex = '9999';

      const box = document.createElement('div');
      box.style.background = '#fff';
      box.style.borderRadius = '8px';
      box.style.padding = '24px 28px';
      box.style.boxShadow = '0 8px 24px rgba(0,0,0,0.18)';
      box.style.minWidth = '280px';
      box.style.textAlign = 'center';

      const title = document.createElement('div');
      title.textContent = '処理中です...';
      title.style.fontSize = '18px';
      title.style.fontWeight = '600';
      title.style.marginBottom = '8px';

      const desc = document.createElement('div');
      desc.textContent = 'カート情報を更新しています';
      desc.style.fontSize = '14px';
      desc.style.color = '#555';

      box.appendChild(title);
      box.appendChild(desc);
      overlay.appendChild(box);
      document.body.appendChild(overlay);
    }
    if (show) {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    } else {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  }

  async function clearCart() {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Failed to clear cart');
    return await response.json();
  }

  async function addToCart(variantId, quantity, properties, sellingPlanId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: properties || {},
        ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}),
      }),
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Add to cart failed:', errorText);
      throw new Error('Failed to add item to cart');
    }
    return await response.json();
  }

  function collectMessagePropertiesForLine(lineIndex, quantity) {
    const props = {};
    let hasProps = false;
    for (let i = 1; i <= quantity; i++) {
      // 既存のDOM命名に合わせたセレクタ（properties[ギフトカードメッセージ_${lineIndex}_${i}]）
      const selector = `textarea[name="properties[ギフトカードメッセージ_${lineIndex}_${i}]"]`;
      const el = document.querySelector(selector);
      const message = (el && el.value ? el.value.trim() : '') || '';
      if (message) {
        // Line: Properties にはキーを「ギフトカードメッセージ_line_qty」の形で保存
        const key = `ギフトカードメッセージ_${lineIndex}_${i}`;
        props[key] = message;
        hasProps = true;
      }
    }
    return hasProps ? props : {};
  }

  // 配送先情報を収集（2つ目以降の商品のみ）
  function collectShippingPropertiesForLine(lineIndex) {
    // 1つ目の商品は配送先オプションなし
    if (lineIndex <= 1) return {};
    
    const props = {};
    const shippingPrefix = `配送先_${lineIndex}`;
    const differentShippingKey = `${shippingPrefix}_異なる配送先`;
    
    // チェックボックスの状態を確認
    const checkbox = document.querySelector(
      `input[name="properties[${differentShippingKey}]"]`
    );
    
    if (!checkbox || !checkbox.checked) return {};
    
    props[differentShippingKey] = 'はい';
    
    // 配送先の各フィールドを収集
    const fields = [
      'お名前',
      'お名前ふりがな',
      '郵便番号',
      '都道府県',
      'ご住所',
      '電話番号'
    ];
    
    fields.forEach(fieldName => {
      const key = `${shippingPrefix}_${fieldName}`;
      const selector = fieldName === '都道府県'
        ? `select[name="properties[${key}]"]`
        : `input[name="properties[${key}]"]`;
      const element = document.querySelector(selector);
      const value = element?.value?.trim() || '';
      if (value) {
        props[key] = value;
      }
    });
    
    return props;
  }

  function buildItemForReAdd(item, idx) {
    const lineIndex = idx + 1;
    const variantId = item.variant_id;
    const quantity = item.quantity;
    
    // 既存のpropertiesからメッセージカード・配送先関連を除外
    // （DOMから再取得するため、重複を防ぐ）
    const existingProps = {};
    Object.keys(item.properties || {}).forEach(key => {
      // メッセージカードと配送先関連のキーは除外
      if (!key.includes('ギフトカードメッセージ_') && 
          !key.includes('メッセージカード選択_') && 
          !key.includes('デザインパターン_') && 
          !key.includes('配送先_')) {
        existingProps[key] = item.properties[key];
      }
    });
    
    const messageProps = collectMessagePropertiesForLine(lineIndex, quantity);
    const shippingProps = collectShippingPropertiesForLine(lineIndex);
    
    const mergedProps = { ...existingProps, ...messageProps, ...shippingProps };

    // selling_plan の保持（定期購入やギフト設定など）
    const sellingPlanId =
      (item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan &&
        item.selling_plan_allocation.selling_plan.id) ||
      item.selling_plan ||
      null;

    return { variantId, quantity, properties: mergedProps, sellingPlanId };
  }

  // チェックアウト処理の共通関数
  async function processCheckout(e) {
    // 二重起動防止
    if (isProcessing) return;
    isProcessing = true;

    e.preventDefault();
    e.stopPropagation();

    // 事前バリデーション：メッセージカード選択が「あり」の場合、必須入力が満たされているか
    const { messageMissing, designMissing } = getMessageCardValidationErrors();
    if (messageMissing || designMissing) {
      isProcessing = false;
      showLoading(false);
      const messages = [];
      if (messageMissing) messages.push('メッセージカードを選択した場合、メッセージの入力が必要です。');
      if (designMissing) messages.push('デザインを選択してください。');
      alert(messages.join('\n'));
      return;
    }

    // 配送先フォームのバリデーション
    const shippingErrors = getShippingValidationErrors();
    if (shippingErrors.length > 0) {
      isProcessing = false;
      showLoading(false);
      alert('配送先情報に不備があります。\n\n' + shippingErrors.join('\n'));
      return;
    }

    showLoading(true);

    try {
      // 現在のカート取得
      const currentCart = await getCart();

      // 追加するアイテムの配列を作成（各ラインの message properties と配送先情報を収集）
      const itemsToAdd = currentCart.items.map((item, idx) => buildItemForReAdd(item, idx));

      if (!itemsToAdd.length) {
        showLoading(false);
        isProcessing = false;
        alert('カートが空です。商品を追加してからお進みください。');
        return;
      }

      // カートをクリア
      await clearCart();

      // properties を付けて再追加（逆順で追加して元の順序を維持）
      const reversedItems = [...itemsToAdd].reverse();
      for (const it of reversedItems) {
        await addToCart(it.variantId, it.quantity, it.properties, it.sellingPlanId);
        // APIへの連続投稿を少し間引き
        await new Promise((resolve) => setTimeout(resolve, 300));
      }

      // チェックアウトへ
      window.location.href = '/checkout';
    } catch (error) {
      console.error('Error updating cart:', error);
      alert('カートの更新に失敗しました。もう一度お試しください。\n\nエラー: ' + error.message);
      showLoading(false);
      isProcessing = false;
      return;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    // カートフォームのsubmitイベント
    const cartForm = document.getElementById('cart');
    if (cartForm) {
      cartForm.addEventListener('submit', processCheckout);
    }

    // 「会員登録なしでレジに進む」ボタンのクリックイベント
    const guestCheckoutBtn = document.querySelector('.guest-checkout-btn');
    if (guestCheckoutBtn) {
      // 親のaタグのデフォルト動作も防止するため、aタグにもリスナーを追加
      const guestCheckoutLink = guestCheckoutBtn.closest('a[href="/checkout"]');
      if (guestCheckoutLink) {
        guestCheckoutLink.addEventListener('click', processCheckout);
      } else {
        // aタグがない場合はボタンに直接
        guestCheckoutBtn.addEventListener('click', processCheckout);
      }
    }

    // その他の /checkout リンクにも対応（オプション）
    // document.querySelectorAll('a[href="/checkout"]').forEach(link => {
    //   link.addEventListener('click', processCheckout);
    // });
  });

  // ブラウザバック時にローディングを非表示にする
  window.addEventListener('pageshow', (event) => {
    // bfcache から復元された場合
    if (event.persisted) {
      showLoading(false);
      isProcessing = false;
    }
    
    // 通常のページ表示でも念のためローディングを非表示
    const overlay = document.getElementById('cart-loading-overlay');
    if (overlay && overlay.style.display !== 'none') {
      showLoading(false);
      isProcessing = false;
    }
  });
})();